

























    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    class AddBaseCost {
        id: number;
        shelfPosition: string;
    }
    @Component
    export default class CreateBaseCostModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        storecost: AddBaseCost = new AddBaseCost();
        addLoding = false;
        shelf: string = "";
        created() {

        }
        signFor() {
            this.save();
        }
        save() {
            (this.$refs.settingcostForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.storecost.id = this.$store.state.backstock.id;
                    this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'backstock/ShelfUp',
                        data: this.storecost
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.settingcostForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }


        cancel() {
            (this.$refs.settingcostForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.$set(this.storecost, "shelfPosition","");
                this.check();
            }
        }
        async check() {
            this.shelf = await this.$store.dispatch({
                type: 'backstock/CheckShelf',
                data: { id: this.$store.state.backstock.id}
            })
            if (this.shelf) {
                this.$set(this.storecost, "shelfPosition", this.shelf);
            }
        }
        costRule = {
            shelfPosition: [
                { required: true, message: '货架号不能为空', trigger: 'blur' }
            ],

        };

    }
